import { orchestrator } from 'satcheljs';
import {
    OAuthProviderType,
    lazyLinkAccountAndGetAccessToken,
    ConnectedAccountResponse,
    ErrorResponse,
} from 'owa-link-account';
import { addSeconds, now } from 'owa-datetime';
import { trace } from 'owa-trace';
import { lazyInitializeOwaConnectedAccount } from 'owa-account-store-init';
import { OWAConnectedAccountState } from 'owa-accounts-store';
import {
    connectOWAConnectedAccountFailed,
    connectOWAAccount,
    accountConnected,
} from '../actions/publicActions';

orchestrator(connectOWAAccount, async ({ accountProviderType, isReconnectFlow, source }) => {
    if (
        accountProviderType == 'Outlook' ||
        accountProviderType == 'Google' ||
        accountProviderType == 'ICloud'
    ) {
        const providerType =
            accountProviderType == 'Outlook'
                ? OAuthProviderType.Msa
                : accountProviderType == 'Google'
                ? OAuthProviderType.Google
                : OAuthProviderType.ICloud;

        try {
            const response = await lazyLinkAccountAndGetAccessToken.importAndExecute(providerType);
            const responseError = response as ErrorResponse;

            // once connected, the use the response to store the account details in client store
            if (!responseError.error) {
                const res = response as ConnectedAccountResponse;
                const tokenExpiration = parseInt(res.token.expiresIn);
                const initializeOwaConnectedAccount = await lazyInitializeOwaConnectedAccount.import();
                initializeOwaConnectedAccount({
                    userIdentity: res.userAccount.emailAddress,
                    accountId: res.userAccount.id,
                    accountUniqueId: res.userAccount.accountUniqueId,
                    anchorMailbox: res.userAccount.routingHint,
                    token: res.token.accessToken,
                    accountProviderType: accountProviderType,
                    tokenExpiry: addSeconds(now(), tokenExpiration),
                    accountState: OWAConnectedAccountState.Valid, // always set the accountState as valid here, because the service call does not refresh token at this point. Refresh token api will take care of setting right state
                });

                // Announce account connected (so that we can enable truetime by default)
                accountConnected(
                    res.userAccount.emailAddress,
                    accountProviderType,
                    res.userAccount.accountUniqueId,
                    source
                );
            } else {
                const errorType = responseError ? responseError.error : 'Unknown';

                trace.warn(
                    'connectOWAAccount failed with ErrorType: ' +
                        errorType +
                        ' ErrorDescription: ' +
                        responseError?.errorDescription
                );
                connectOWAConnectedAccountFailed(
                    isReconnectFlow,
                    errorType,
                    accountProviderType,
                    source
                );
            }
        } catch (e) {
            trace.warn('connectOWAAccount failed with Error: ' + e);
            connectOWAConnectedAccountFailed(
                isReconnectFlow,
                'Exception',
                accountProviderType,
                source
            );
        }
    } else {
        throw new Error(`${accountProviderType} provider is not yet supported for OWA Calendar`);
    }
});
